import axios, { AxiosPromise, AxiosRequestConfig } from 'axios'

export class Cnes {
  importar(formData: FormData, municipioId: ID, config?: AxiosRequestConfig): AxiosPromise<void> {
    return axios.post(`/api/cnes/${municipioId}`, formData, config)
  }
}
